export default function AuraGlow({
  className = "",
  size = 600,
  color = "#4DA3FF",
  opacity = 0.18,
  blur = 140,
  drift = false,
}) {
  return (
    <div
      aria-hidden="true"
      className={`pointer-events-none absolute rounded-full ${drift ? "animate-aura-drift" : "animate-aura-pulse"} ${className}`}
      style={{
        width: size,
        height: size,
        background: color,
        opacity,
        filter: `blur(${blur}px)`,
      }}
      data-testid="aura-glow"
    />
  );
}
